<template>
    <div class='lock-it-in-header-container' id='lock-it-in-header'>
        <div class='header-container'>
            <img class='logo' src="/images/lock_it_in/majestic-logo.webp"  @click='goToHome'> 
            <div class='right-side'>
                <div v-if='!loading' v-show='!hide_buttons' class='buttons-container'>
                    <button v-show='!logged_in' @click='goToLogin' class='login-button'>Sign in</button>
                    <a v-show='logged_in' class='account-link switch-text' @click='toGoWineClubAccount'>Switch to Wine Club </a>
                    <a v-show='logged_in && !mobile_mode' class='account-link' @click='toGoAccount'>Account </a>
                    <a v-show='logged_in && mobile_mode' class='account-link' @click='toGoAccount'><i class="fa-solid fa-user"></i> </a>

                    <button v-show='logged_in && !mobile_mode' @click='logout' class='login-button'>Logout</button>
                    <a  class='account-link' v-show='logged_in && mobile_mode' @click='logout'><i class="fa-solid fa-arrow-right-from-bracket"></i></a>

                </div>
                <div v-if='loading' class='loading-container'>
                    <Loading/>
                </div>
                <!-- <Basket :updated_cart_watcher='updated_cart_watcher'/> -->
            </div>
        </div>
        
        <Banner v-show='!hide_banner'/>
    </div>
</template>

<script>
import Basket from '@/ecom/components/header/basket/Basket.vue';
import {checkAuth} from "@/global/modules/functions.js";
import Banner from '@/ecom/components/header/lock_it_in/Banner.vue';
import Loading from '@/ecom/components/loading/Loading.vue';

export default {
    components: {Basket, Banner, Loading},
    props:['updated_cart_watcher', 'current_route', 'login_changed'],
    data(){
        return{
            hide_buttons: false,
            hide_banner: false,
            logged_in : false,
            loading: true,
            screen_size_check_timeout: null,
            mobile_mode: false
        }
    },
    methods:{
        goToLogin(){
            this.$router.push('/lock-it-in/login?redirect_url=lock-it-in/members');
        },
        toGoAccount(){
            this.$router.push('/lock-it-in/members');
        },
        goToHome(){
            this.$router.push('/');
        },
        toGoWineClubAccount(){
            this.$router.push('/wine-club/members');
        },
        async checkLoggedin(){
            this.loading = true;
           
            let response = await fetch(`/api/user/check-logged-in`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(results == true){
                    this.logged_in = true;
                }
            }
            this.loading = false;
        },
        hideShowElements(route){
            if(route == '/lock-it-in/login' || route == '/lock-it-in/login/'){
                this.hide_buttons = true;
            }

            if(route == '/lock-it-in' || route == '/lock-it-in/'){
                this.hide_banner = true;
            }

            if(route == '/lock-it-in/members'){
                this.hide_banner = false;
            }
        },
        async logout(){
            let response = await fetch(`/api/user/logout`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({}),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.logged_in = false;
                this.setLogoutLocalStorage();
                window.location.href = '/';
            }
        },
        CheckMobileMode(){
            let lock_it_in_header = document.getElementById('lock-it-in-header');
            if(typeof lock_it_in_header !== 'undefined'){
                new ResizeObserver(()=>{
                    clearTimeout(this.screen_size_check_timeout);

                    this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                        if(lock_it_in_header.clientWidth <= 768){
                            this.mobile_mode = true;
                        }
                        else{
                            this.mobile_mode = false;
                        }
                    }, 1);
                }).observe(lock_it_in_header);
            }
        },
        setLogoutLocalStorage(){
            let logout_watcher = +new Date();
            localStorage.setItem('logout_watcher', logout_watcher);
        }
    },
     beforeMount(){
        this.checkLoggedin();
        this.hideShowElements(this.$route.path);
    },
    mounted(){
        this.CheckMobileMode();
    },
    watch: {
        $route(to, from) {
            this.hideShowElements(to.path);
        },
        'login_changed': function(){
            this.hide_buttons = false;
            this.checkLoggedin();
        }
    }
 
}
</script>

<style lang="scss" scoped>
.lock-it-in-header-container{
    background-color: white;
}

.header-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 4rem 0.5rem 4rem;

    @media(max-width: 768px){
        padding: 0.5rem 1rem 0.5rem 1rem;
    }
}

.logo{
    height: 50px;
    cursor: pointer;
    
     @media(max-width: 768px){
        height: auto;
        width: 150px;
    }
}

.login-button{
        background: none;
        color: var(--maj-dark-green);
        border-radius: 30px;
        padding: 2px 30px;
        height: 42px;
        border: 1px solid var(--maj-dark-green);
        font-size: 0.9rem;
        cursor: pointer;
}

.right-side{
    display: flex;
    gap: 24px;
    align-items: center;
}

 .buttons-container{
        display: flex;
        gap: 24px;
        align-items: center;

           @media(max-width: 768px){
            gap: 16px;
        }
    }

    .account-link{
        color: var(--maj-slate);
        cursor: pointer;
        &:hover{
            text-decoration: underline;
        }
    }

.loading-container{
    width: 25px;
    height: 25px;
    margin-right: 40px;
}

.switch-text{
    @media(max-width: 768px){
        font-size: 0.76rem;
        font-weight: 300;
    }
}
</style>